import React from 'react'
import ExpiredSubscriptionSvg from 'assets/images/expired-subscription.svg'
import Button from 'components/ui/button'
import DiscoModal from 'components/ui/disco-modal'
import Heading from 'components/ui/heading'
import modalStyles from 'components/utils/modalStyles'
import styles from './index.module.css'

const ExpiredSubscriptionModal = ({
  href,
  onClose,
}:
  | {
      href: string
    }
  | {
      onClose: (...args: Array<any>) => any
    }): React.ReactNode => (
  <DiscoModal isOpen style={modalStyles} onRequestClose={onClose}>
    <div className={styles.expiredSubscriptionModal}>
      <ExpiredSubscriptionSvg className={styles.expiredSubscriptionModalSvg} />
      <Heading size="600">Your subscription has expired</Heading>
      <p className={styles.expiredSubscriptionModalDescription}>
        To restart your subscription, click the button below.
      </p>
      <Button
        caption={
          href
            ? 'Restart Subscription (Chargebee Growth demo)'
            : 'Restart Subscription'
        }
        appearance="primary"
        link={href}
        linkTarget="_blank"
        onClick={onClose}
      />
    </div>
  </DiscoModal>
)

export default ExpiredSubscriptionModal
